import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Linkdin = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 40.578H10a10 10 0 0 1-10-10v-20a10 10 0 0 1 10-10h20a10 10 0 0 1 10 10v20a10 10 0 0 1-10 10Z"
        fill="#2864B4"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.75 11.828H30A5.625 5.625 0 0 0 30.575.607c-.191-.01-.38-.029-.575-.029H10a10 10 0 0 0-10 10v20a18.75 18.75 0 0 1 18.75-18.75Z"
        fill="#417DCD"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 20.578a10 10 0 1 0 10 10v-20a10 10 0 0 1-10 10Z"
        fill="#0F4B9B"
      />
      <Path
        d="M11.25 16.203h-2.5c-.69 0-1.25.56-1.25 1.25v14.375c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25V17.453c0-.69-.56-1.25-1.25-1.25ZM10 13.703a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Z"
        fill="#fff"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.25 18.478a5.76 5.76 0 0 1 5-2.9c3.18 0 6.25 1.875 6.25 6.875v9.375a1.248 1.248 0 0 1-1.25 1.25h-2.5a1.249 1.249 0 0 1-1.25-1.25v-8.75a3.125 3.125 0 1 0-6.25 0v8.75a1.248 1.248 0 0 1-1.25 1.25h-2.5a1.249 1.249 0 0 1-1.25-1.25V17.453a1.249 1.249 0 0 1 1.25-1.25H20a1.25 1.25 0 0 1 1.25 1.25v1.025Z"
        fill="#fff"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(0 .578)" d="M0 0h40v40H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Linkdin
